const basicMeta = [
  {
    name: "keywords",
    content:
      "formule1, formula, formula 1, f1, formuleets, formule-ets, formule, ets, student, website, ca, canada, quebec, sponsors, team, photos, videos, club, project, sponsors, donate, media, 3d, presentation, about",
  },
  {
    name: "robots",
    content: "index, follow",
  },
  {
    "http-equiv": "Content-Type",
    content: "text/html; charset=utf-8",
  },
  {
    name: "author",
    content: "formuleets",
  },
  {
    property: "og:image",
    content: "/og-image.png",
  },
];

export default basicMeta;
